/**
 * Basic Theme - Uses standard HTML inputs
 * This is the default theme, wrapping current UI elements
 */

import { BasicKnob } from './BasicKnob.js';
import { BasicSlider } from './BasicSlider.js';
import { BasicStepButton } from './BasicStepButton.js';
import { BasicSelect } from './BasicSelect.js';
import { BasicLED } from './BasicLED.js';

/**
 * Create a knob component
 * @param {HTMLElement} container
 * @param {Object} options
 * @returns {BasicKnob}
 */
export function createKnob(container, options) {
    return new BasicKnob(container, options);
}

/**
 * Create a slider component
 * @param {HTMLElement} container
 * @param {Object} options
 * @returns {BasicSlider}
 */
export function createSlider(container, options) {
    return new BasicSlider(container, options);
}

/**
 * Create a step button component
 * @param {HTMLElement} container
 * @param {Object} options
 * @returns {BasicStepButton}
 */
export function createStepButton(container, options) {
    return new BasicStepButton(container, options);
}

/**
 * Create a select component
 * @param {HTMLElement} container
 * @param {Object} options
 * @returns {BasicSelect}
 */
export function createSelect(container, options) {
    return new BasicSelect(container, options);
}

/**
 * Create an LED component
 * @param {HTMLElement} container
 * @param {Object} options
 * @returns {BasicLED}
 */
export function createLED(container, options) {
    return new BasicLED(container, options);
}

// Export classes for direct use if needed
export { BasicKnob, BasicSlider, BasicStepButton, BasicSelect, BasicLED };
